import { Component, Input } from '@angular/core';
// Side-effect import required: errorMessage.ts patches Array.prototype with
// countTestTrue(), which the template calls. A type-only import gets elided.
import '../input-error-list/errorMessage';
import { ErrorMessage } from '../input-error-list/errorMessage';

@Component({
  selector: 'app-input-error-icon',
  templateUrl: './input-error-icon.component.html',
  styleUrls: ['./input-error-icon.component.css']
})
export class InputErrorIconComponent {
  @Input() errors: ErrorMessage[] = [];

}
